var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 9.99998C2.08325 6.26803 2.08325 4.40205 3.24262 3.24268C4.40199 2.08331 6.26797 2.08331 9.99992 2.08331C13.7318 2.08331 15.5978 2.08331 16.7573 3.24268C17.9166 4.40205 17.9166 6.26803 17.9166 9.99998C17.9166 13.7319 17.9166 15.5979 16.7573 16.7573C15.5978 17.9166 13.7318 17.9166 9.99992 17.9166C6.26797 17.9166 4.40199 17.9166 3.24262 16.7573C2.08325 15.5979 2.08325 13.7319 2.08325 9.99998Z",
    stroke: "#423F5A",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 10.4167L8.75008 12.5L13.3334 7.5",
    stroke: "#423F5A",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessTick);
export default __webpack_public_path__ + "static/media/access-tick.9011fb98648c97a3cbd76d7773c65afe.svg";
export { ForwardRef as ReactComponent };